/**
 * Metadata for cs_platform_credentials UI fields.
 *
 * Keyed by `cs_platform` (account.cs_platform). Each entry is an array
 * of fields to render in the Edit Account dialog under "Credentials".
 *
 * Adding a new credential key = add one entry here. No other changes needed
 * to TenantManagement.js (the form renders fields, handleEditAccount seeds
 * state, and handleUpdateAccount computes the jsonb delta — all driven by
 * this constant).
 *
 * Supported field types today: "url", "text". Add a "password" branch to the
 * renderer in TenantManagement.js if/when a secret field is exposed here.
 */
export const CS_PLATFORM_CREDENTIAL_FIELDS = {
  chatwoot: [
    {
      key: "chatwoot_public_api_url",
      label: "Chatwoot Public API URL",
      type: "url",
      placeholder: "https://chatwoot.example.com",
      help: "Used by the widget endpoint to reach Chatwoot's Public API. Leave empty to fall back on the server-wide default.",
    },
  ],
};

/** Returns the list of credential fields for a platform, or [] if unknown/undefined. */
export const getCredentialFields = (csPlatform) =>
  CS_PLATFORM_CREDENTIAL_FIELDS[csPlatform] || [];
